import React from 'react'
import { useTranslation } from 'react-i18next'

import { Select } from 'components/forms'

const FilterComponent = () => {
	const [t] = useTranslation()
	return(
		<Select
			field='groupId'
			label={t('common.strings.group')}
			options={[
				{ label: `${t('common.strings.group')} 1`, value: '1' },
				{ label: `${t('common.strings.group')} 2`, value: '2' },
				{ label: `${t('common.strings.group')} 3`, value: '3' }
			]}
		/>
	)
}


export default FilterComponent
